module.exports = __webpack_public_path__ + "img/ltkbaby-4x.81a3d7c.jpg";